module.exports = __webpack_public_path__ + "img/erroricon.bd952f83.svg";